// 'use strict';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { WithContext as ReactTags } from 'react-tag-input';
// import './style.css';



class TagsComponent extends React.Component{
    constructor(props){
        super(props);

        this.state={
            tags:[]
        }

        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.handleTagClick = this.handleTagClick.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleStateToParent = this.handleStateToParent.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }


    handleAddition(tag) {
        let updatedTags = [...this.props.tags, tag];
        this.handleStateToParent(updatedTags,this);
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.props.tags];
        const updatedTags = tags.slice();

        updatedTags.splice(currPos, 1);
        updatedTags.splice(newPos, 0, tag);
        this.handleStateToParent(updatedTags,this);
    
    }

    handleDelete(i) {
        let tags = this.props.tags;
        let updatedTags = tags.filter((tag, index) => index !== i);
        this.handleStateToParent(updatedTags,this);
    }

    handleTagClick(index) {
        if (this.props.tagClick !== null && this.props.tagClick !== undefined ){
            var clickedTag = this.props.tags[index];
            this.props.tagClick(clickedTag);
        }
        // console.log('The tag at index ' + index + ' was clicked');
    }

    handleStateToParent(data,reference) {
        this.props.controlState(data,reference);
    }

    handleChange(e){
    }

    render(){

        const KeyCodes = {
            comma: 188,
            enter: 13,
        };

        const delimiters = [KeyCodes.comma, KeyCodes.enter];

        // takes the tags and suggestions in the following format
        // [{"id": "abc","text":"xyz" }]
        let tag_body_name = (this.props.name !== undefined && this.props.name !== null) ? this.props.name:"tag";
        let tag_body_id = (this.props.id !== undefined && this.props.id !== null) ? this.props.id : `${tag_body_name}_id`;
        
        var body = (
        <ReactTags
            classNames={this.props.classNames ? this.props.classNames : null}
            id={tag_body_id}
            name={tag_body_name}
            placeholder={this.props.placeholder}
            tags={this.props.tags}
            suggestions={this.props.suggestions}
            autofocus={false}
            delimiters={delimiters}
            handleDelete={this.handleDelete}
            handleAddition={this.handleAddition}
            handleDrag={this.handleDrag}
            handleTagClick={this.handleTagClick}
            minQueryLength={0}
            inputFieldPosition="bottom"
            allowDeleteFromEmptyInput={false}
            handleInputChange={this.handleChange}
            readOnly={this.props.readOnly}
        />);

        return body;
    }
}

export default TagsComponent;